import { Component, OnInit } from '@angular/core';
import { Department, ResponseDataBase, Subdepartment } from '../../../../../interfaces/index.interface';
import { ResourceService, UserService } from '../../../../../services/index.service';
import { DatabaseResourcesService } from '@services/database-resources/database-resources.service';
import { AppConstants } from '@app/appConstants';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfirmationModalComponent } from '@components/modals/confirmation-modal/confirmation-modal.component';
import { TranslateService } from '@ngx-translate/core';
import { Hospital } from '../../../../../interfaces/hospital.interface';
import { Consultant } from '../../../../../interfaces/consultant.interface';
import { Router } from '@angular/router';
import { environment } from '@environments/environment';

declare var $: any;

@Component({
  selector: 'database-resources-edit-consultant',
  templateUrl: './edit-consultant.page.html'
})
export class EditConsultantPage implements OnInit {

  hospitals: Array<Hospital>;
  hospital: Hospital;
  selectedHospital;
  department: Department;
  departments: Array<Department>;
  subdepartment: Subdepartment;
  subdepartments: Array<Subdepartment>;
  alertShedule;
  alertException;
  action;
  consultant: Consultant = {
    id: '',
    name: '',
    email: ''
  };
  originalConsultant: Consultant = {
    id: '',
    name: '',
    email: ''
  };
  activeDepartmentTab;
  activeSubdepartmentTab;
  selectUndefinedOptionValue;
  editVisitDuration = false;

  constructor(public _resourceService: ResourceService, public modalService: NgbModal, public router: Router,
    public _databaseResourcesService: DatabaseResourcesService,
    public translate: TranslateService, public _userService: UserService,) {
    if (!_databaseResourcesService.haveAllResources()) {
      this._databaseResourcesService.getAllResources();
    }
    if (this._userService.user.role == "consultant") {
      this.getConsultant(this._userService.user.email);
    } else {
      if (!_databaseResourcesService.consultant) {
        // this.router.navigate(['/admin/database-resources/consultants']);
        this.getConsultant("soyjuanmed");
      } else {
        this.getConsultant(_databaseResourcesService.consultant.id);
      }
    }
  }

  convertScheduleToScheduleDays(schedule) {
    this.consultant.scheduleDays = [];
    this.consultant.exceptions = [];
    for (var day in schedule) {
      if (day != 'visitDuration' && day != 'hospital') {
        if (day != 'exceptions') {
          this.consultant.schedule[day] = JSON.parse(this.consultant.schedule[day]);
          this.consultant.schedule[day].name = day;
          this.consultant.scheduleDays.push(this.consultant.schedule[day]);
        } else {
          this.consultant.schedule[day] = JSON.parse(this.consultant.schedule[day]);
          this.consultant.schedule[day].name = day;
          this.consultant.exceptions.push(this.consultant.schedule[day]);
        }
      }
    }
  }

  convertScheduleToHospitalSchedulesScheduleDays(schedule) {
    let hospitalSchedule = [];
    hospitalSchedule['days'] = []
    hospitalSchedule['hospital'] = schedule.hospital;
    hospitalSchedule['visitDuration'] = schedule.visitDuration;
    hospitalSchedule['exceptions'] = [];
    for (var day in schedule) {
      if (day != 'visitDuration' && day != 'hospital') {
        if (day != 'exceptions') {
          schedule[day] = JSON.parse(schedule[day]);
          schedule[day].name = day.toUpperCase();
          hospitalSchedule['days'].push(schedule[day]);
        } else {
          schedule[day] = JSON.parse(schedule[day]);
          schedule[day].name = day.toUpperCase();
          hospitalSchedule['exceptions'].push(schedule[day]);
        }
      }
    }
    this.consultant.hospitalSchedules.push(hospitalSchedule);
  }

  getConsultant(email) {
    let params = {
      email: email
    };
    this._databaseResourcesService.getConsultant(params)
      .subscribe(data => {
        let response = data as ResponseDataBase;
        if (response.METADATA.STATUS == AppConstants.STATUS.OK) {
          this.consultant = response.result[0];
          this.originalConsultant = JSON.parse(JSON.stringify(this.consultant));
        } else {
          this._resourceService.alert = response.METADATA.ERROR_MESSAGE;
        }
        this._databaseResourcesService.loading = false;
      });
  }

  getAllAssistants() {
    this._databaseResourcesService.getAllAssistants();
  }

  openModal(hospital) {
    $('#addSubdepartmentToConsultantModal').modal('toggle');
    this.getDepartments(hospital)
  }

  updateConsultant() {
    if (!this.consultant.personalData.name || !this.consultant.personalData.lastname || !this.consultant.personalData.phoneNumber) {
      this._resourceService.alert = "ALL_FIELDS_ARE_MANDATORY";
    } else {
      delete this._resourceService.alert;
      let params: any = {
        name: this.consultant.personalData.name,
        lastname: this.consultant.personalData.lastname,
        email: this.consultant.personalData.email,
        phoneNumber: this.consultant.personalData.phoneNumber,
        address: this.consultant.personalData.address,
        flatNumber: this.consultant.personalData.flatNumber
      }
      this._databaseResourcesService.updateConsultant(params).subscribe(data => {
        let response = data as ResponseDataBase;
        if (response.METADATA.STATUS == AppConstants.STATUS.OK) {
          delete this.action;
          this.originalConsultant = JSON.parse(JSON.stringify(this.consultant));
        } else {
          this._resourceService.alert = response.METADATA.ERROR_MESSAGE;
        }
        delete this.action;
        this._databaseResourcesService.loading = false;
      });
    }
  }

  saveVisitDuration(hospitalSchedule) {
    let params: any = {
      id: this.consultant.id,
      email: this.consultant.personalData.email,
      visitDuration: hospitalSchedule.visitDuration,
      hospitalId: hospitalSchedule.hospital.id
    }
    this._databaseResourcesService.updateConsultant(params).subscribe(data => {
      let response = data as ResponseDataBase;
      if (response.METADATA.STATUS == AppConstants.STATUS.OK) {
        delete this.action;
        this.originalConsultant = JSON.parse(JSON.stringify(this.consultant));
      } else {
        this._resourceService.alert = response.METADATA.ERROR_MESSAGE;
      }
      delete this.action;
      this._databaseResourcesService.loading = false;
    });
  }

  deleteConsultantFromUnit(department, subdepartment, consultant) {
    let unit = {
      id: department.id,
      type: 'department',
    };
    if (subdepartment) {
      unit.id = subdepartment.id;
      unit.type = 'subdepartment';
    }
    let modal = this.modalService.open(ConfirmationModalComponent, {
      windowClass: 'modal-fade',
      backdrop: 'static',
      keyboard: false,
      size: 'sm'
    });
    modal.componentInstance.header = 'DELETE_CONSULTANT_FROM_UNIT';
    modal.componentInstance.message = 'CONFIRM_DELETE';
    modal.componentInstance.data = { action: "delete", consultant: consultant, unit: unit };
    modal.componentInstance.action.subscribe((response) => {
      this.confirmDeleteConsultantFromUnit(response.consultant, response.unit);
    });
  }

  confirmDeleteConsultantFromUnit(consultant, unit) {
    let params = {
      consultantId: consultant.id,
      unitId: unit.id,
      unitType: unit.type
    }
    this._databaseResourcesService.deleteConsultantFromUnit(params).subscribe(data => {
      let response = data as ResponseDataBase;
      if (response.METADATA.STATUS == AppConstants.STATUS.OK) {
        this.translate.get('HAS_BEEN_DELETED').subscribe(
          translation => {
            this.translate.get('FROM_UNIT').subscribe(
              translation2 => {
                let name = consultant.name
                this._resourceService.alert = name + " " + translation + translation2;
              });
          });
        this.getConsultant(this.consultant.id);
      } else {
        this._resourceService.alert = response.METADATA.ERROR_MESSAGE;
        this._databaseResourcesService.loading = false;
      }
    });
  }

  assignHospitalToConsultant(hospital) {
    let params = {
      id: this.consultant.id,
      hospitalId: hospital.id
    }
    this._databaseResourcesService.assignHospitalToConsultant(params).subscribe(data => {
      let response = data as ResponseDataBase;
      if (response.METADATA.STATUS == AppConstants.STATUS.OK) {
        this.getConsultant(this.consultant.id);
      } else {
        this._resourceService.alert = response.METADATA.ERROR_MESSAGE;
      }
      delete this.action;
      this._databaseResourcesService.loading = false;
    });
    delete this.hospital;
    delete this.departments;
    delete this.department;
    delete this.subdepartments;
  }

  assignDepartmentToConsultant(department) {
    let params = {
      id: this.consultant.id,
      departmentId: department.id
    }
    this._databaseResourcesService.assignDepartmentToConsultant(params).subscribe(data => {
      let response = data as ResponseDataBase;
      if (response.METADATA.STATUS == AppConstants.STATUS.OK) {
        this.getConsultant(this.consultant.id);
      } else {
        this._resourceService.alert = response.METADATA.ERROR_MESSAGE;
        this._databaseResourcesService.loading = false;
      }
      delete this.action;
    });
    delete this.hospital;
    delete this.departments;
    delete this.department;
    delete this.subdepartments;
  }

  removeDepartmentFromConsultant(departmentId) {
    let modal = this.modalService.open(ConfirmationModalComponent, {
      windowClass: 'modal-fade',
      backdrop: 'static',
      keyboard: false,
      size: 'sm'
    });
    modal.componentInstance.header = 'REMOVE_DEPARTMENT_FROM_CONSULTANT';
    modal.componentInstance.message = 'CONFIRM_REMOVE';
    modal.componentInstance.data = { action: "delete", departmentId: departmentId };
    modal.componentInstance.action.subscribe((response) => {
      this.confirmRemoveDepartmentFromConsultant(response.departmentId);
    });
  }

  confirmRemoveDepartmentFromConsultant(departmentId) {
    let params = {
      id: this.consultant.id,
      departmentId: departmentId
    }
    this._databaseResourcesService.removeDepartmentFromConsultant(params).subscribe(data => {
      let response = data as ResponseDataBase;
      if (response.METADATA.STATUS == AppConstants.STATUS.OK) {
        this.getConsultant(this.consultant.id);
      } else {
        this._resourceService.alert = response.METADATA.ERROR_MESSAGE;
        this._databaseResourcesService.loading = false;
      }
    });
  }

  assignSubdepartmentToConsultant(subdepartment) {
    let params = {
      id: this.consultant.id,
      subdepartmentId: subdepartment.id,
      departmentId: subdepartment.parentId
    }
    this._databaseResourcesService.assignSubdepartmentToConsultant(params).subscribe(data => {
      let response = data as ResponseDataBase;
      if (response.METADATA.STATUS == AppConstants.STATUS.OK) {
        this.getConsultant(this.consultant.id);
      } else {
        this._resourceService.alert = response.METADATA.ERROR_MESSAGE;
        this._databaseResourcesService.loading = false;
      }
      delete this.action;
    });
    delete this.hospital;
    delete this.departments;
    delete this.department;
    delete this.subdepartments;
  }

  removeSubdepartmentFromConsultant(subdepartment) {
    let modal = this.modalService.open(ConfirmationModalComponent, {
      windowClass: 'modal-fade',
      backdrop: 'static',
      keyboard: false,
      size: 'sm'
    });
    modal.componentInstance.header = 'REMOVE_SUBDEPARTMENT_FROM_CONSULTANT';
    modal.componentInstance.message = 'CONFIRM_REMOVE';
    modal.componentInstance.data = { action: "delete", subdepartment: subdepartment };
    modal.componentInstance.action.subscribe((response) => {
      this.confirmRemoveSubdepartmentFromConsultant(response.subdepartment);
    });
  }

  confirmRemoveSubdepartmentFromConsultant(subdepartment) {
    console.log('subdepartment', subdepartment);
    let params = {
      id: this.consultant.id,
      subdepartmentId: subdepartment.id
    }
    this._databaseResourcesService.removeSubdepartmentFromConsultant(params).subscribe(data => {
      let response = data as ResponseDataBase;
      if (response.METADATA.STATUS == AppConstants.STATUS.OK) {
        // TODO buscar otro modo de eliminar también el departamento en el cliente GEA que es una particularidad
        if (environment.envName == 'gea') {
          console.log('parentId', subdepartment.parentId);
          this.confirmRemoveDepartmentFromConsultant(subdepartment.parentId);
        } else {
          this.getConsultant(this.consultant.id);
        }

      } else {
        this._resourceService.alert = response.METADATA.ERROR_MESSAGE;
        this._databaseResourcesService.loading = false;
      }
    });
  }

  getDepartments(hospital) {
    delete this.departments;
    let params = {
      hospitalId: hospital.id,
    };
    this._databaseResourcesService.getDepartments(params)
      .subscribe(data => {
        let response = data as ResponseDataBase;
        this.departments = response.result;
        this._databaseResourcesService.loading = false;
      });
  }

  getSubdepartments(department) {
    let params = {
      departmentId: department.id,
    };
    this._databaseResourcesService.getSubdepartments(params)
      .subscribe(data => {
        let response = data as ResponseDataBase;
        this.subdepartments = response.result;
        this._databaseResourcesService.loading = false;
      });
  }

  assignPayorToConsultant(payor) {
    let params = {
      id: this.consultant.id,
      payorId: payor.id
    }
    this._databaseResourcesService.assignPayorToConsultant(params).subscribe(data => {
      let response = data as ResponseDataBase;
      if (response.METADATA.STATUS == AppConstants.STATUS.OK) {
        this.getConsultant(this.consultant.id);
      } else {
        this._resourceService.alert = response.METADATA.ERROR_MESSAGE;
      }
      delete this.action;
      this._databaseResourcesService.loading = false;
    });
    delete this.hospital;
    delete this.departments;
    delete this.department;
    delete this.subdepartments;
  }

  assignAssistantToConsultant(assistant) {
    let params = {
      id: this.consultant.id,
      assistantId: assistant.email
    }
    this._databaseResourcesService.assignAssistantToConsultant(params).subscribe(data => {
      let response = data as ResponseDataBase;
      if (response.METADATA.STATUS == AppConstants.STATUS.OK) {
        this.getConsultant(this.consultant.id);
      } else {
        this._resourceService.alert = response.METADATA.ERROR_MESSAGE;
      }
      delete this.action;
      this._databaseResourcesService.loading = false;
    });
    delete this.hospital;
    delete this.departments;
    delete this.department;
    delete this.subdepartments;
  }

  removeAssistantFromConsultant(assistant) {
    let modal = this.modalService.open(ConfirmationModalComponent, {
      windowClass: 'modal-fade',
      backdrop: 'static',
      keyboard: false,
      size: 'sm'
    });
    modal.componentInstance.header = 'REMOVE_ASSISTANT_FROM_CONSULTANT';
    modal.componentInstance.message = 'CONFIRM_REMOVE';
    modal.componentInstance.data = { action: "delete", assistant: assistant };
    modal.componentInstance.action.subscribe((response) => {
      this.confirmRemoveAssistantFromConsultant(response.assistant);
    });
  }

  confirmRemoveAssistantFromConsultant(assistant) {
    let params = {
      id: this.consultant.id,
      assistantId: assistant.email
    }
    this._databaseResourcesService.removeAssistantFromConsultant(params).subscribe(data => {
      let response = data as ResponseDataBase;
      if (response.METADATA.STATUS == AppConstants.STATUS.OK) {
        this.getConsultant(this.consultant.id);
      } else {
        this._resourceService.alert = response.METADATA.ERROR_MESSAGE;
      }
      this._databaseResourcesService.loading = false;
    });
  }

  removeConsultantFromHospital(hospital) {
    let modal = this.modalService.open(ConfirmationModalComponent, {
      windowClass: 'modal-fade',
      backdrop: 'static',
      keyboard: false,
      size: 'sm'
    });
    modal.componentInstance.header = 'REMOVE_HOSPITAL_FROM_CONSULTANT';
    modal.componentInstance.message = 'CONFIRM_REMOVE';
    modal.componentInstance.data = { action: "delete", hospital: hospital };
    modal.componentInstance.action.subscribe((response) => {
      this.confirmRemoveConsultantFromHospital(response.hospital);
    });
  }

  confirmRemoveConsultantFromHospital(hospital) {
    let params = {
      id: this.consultant.id,
      hospitalId: hospital.id
    }
    this._databaseResourcesService.removeConsultantFromHospital(params).subscribe(data => {
      let response = data as ResponseDataBase;
      if (response.METADATA.STATUS == AppConstants.STATUS.OK) {
        this.getConsultant(this.consultant.id);
      } else {
        this._resourceService.alert = response.METADATA.ERROR_MESSAGE;
      }
      this._databaseResourcesService.loading = false;
    });
  }

  removePayorFromConsultant(payor) {
    let modal = this.modalService.open(ConfirmationModalComponent, {
      windowClass: 'modal-fade',
      backdrop: 'static',
      keyboard: false,
      size: 'sm'
    });
    modal.componentInstance.header = 'REMOVE_PAYOR_FROM_CONSULTANT';
    modal.componentInstance.message = 'CONFIRM_REMOVE';
    modal.componentInstance.data = { action: "delete", payor: payor };
    modal.componentInstance.action.subscribe((response) => {
      this.confirmRemovePayorFromConsultant(response.payor);
    });
  }

  confirmRemovePayorFromConsultant(payor) {
    let params = {
      id: this.consultant.id,
      payorId: payor.id
    }
    this._databaseResourcesService.removePayorFromConsultant(params).subscribe(data => {
      let response = data as ResponseDataBase;
      if (response.METADATA.STATUS == AppConstants.STATUS.OK) {
        this.getConsultant(this.consultant.id);
      } else {
        this._resourceService.alert = response.METADATA.ERROR_MESSAGE;
      }
      this._databaseResourcesService.loading = false;
    });
  }

  addSchedule(schedule) {
    let newSchedule = {
      startTime: "00:00",
      endTime: "00:00",
      editing: true
    }
    if (!schedule.times) {
      schedule.times = [];
    }
    schedule.times.push(newSchedule);
    schedule.times.editing = true;
  }

  saveTime(hospitalSchedule, day, time) {
    delete this.alertShedule;
    delete this.alertException;
    if (day == 'EXCEPTION') {
      if (time.endTime < time.startTime) {
        this.alertException = "END_EXCEPTION_MUST_BE_GREATER_THAN_START";
      } else {
        this.executeSaveTime(hospitalSchedule, day, time);
      }
    } else {
      if (time.startTime >= time.endTime) {
        this.alertShedule = "END_MUST_BE_GREATER_THAN_START";
      } else {
        this.executeSaveTime(hospitalSchedule, day, time);
      }
    }
  }

  executeSaveTime(hospitalSchedule, day, time) {
    let params = {
      id: time.id,
      consultantId: this.consultant.id,
      day: day,
      startTime: time.startTime,
      endTime: time.endTime,
      hospitalId: hospitalSchedule.hospital.id
    }
    this._databaseResourcesService.saveTime(params).subscribe(data => {
      let response = data as ResponseDataBase;
      if (response.METADATA.STATUS == AppConstants.STATUS.OK) {
        this.getConsultant(this.consultant.id);
      } else {
        this._resourceService.alert = response.METADATA.ERROR_MESSAGE;
      }
      delete this.action;
      this._databaseResourcesService.loading = false;
    });
  }

  removeTime(time) {
    let modal = this.modalService.open(ConfirmationModalComponent, {
      windowClass: 'modal-fade',
      backdrop: 'static',
      keyboard: false,
      size: 'sm'
    });
    modal.componentInstance.header = 'REMOVE_FROM_SCHEDULE';
    modal.componentInstance.message = 'CONFIRM_REMOVE';
    modal.componentInstance.data = { action: "delete", time: time };
    modal.componentInstance.action.subscribe((response) => {
      this.confirmRemoveTime(response.time);
    });
  }

  confirmRemoveTime(time) {
    let params = {
      id: time.id
    }
    this._databaseResourcesService.deleteScheduleTime(params).subscribe(data => {
      let response = data as ResponseDataBase;
      if (response.METADATA.STATUS == AppConstants.STATUS.OK) {
        this.getConsultant(this.consultant.id);
      } else {
        this._resourceService.alert = response.METADATA.ERROR_MESSAGE;
        this._databaseResourcesService.loading = false;
      }
    });
  }

  assignDepartment(department) {
    this.department = department;
  }

  cancelEdit() {
    delete this.action;
    this.consultant = JSON.parse(JSON.stringify(this.originalConsultant));
  }

  addException(exception) {
    let newException = {
      startTime: '',
      endTime: '',
      editing: true
    }
    if (!exception.times) {
      exception.times = [];
    }
    exception.times.push(newException);
    exception.times.editing = true;
  }

  saveException(hospitalSchedule, exception, period) {
    if (!period.firstDay || !period.lastDay) {
      this._resourceService.alert = "PLASE_SELECT_DAYS_FOR_EXCEPTION";
      window.scrollTo(0, 0);
    } else {
      delete this._resourceService.alert;
      if (!exception.periods.length) {
        exception.has = false
      }
      let params = {
        id: this.consultant.id,
        day: exception.name,
        schedule: JSON.stringify(exception),
        hospitalId: hospitalSchedule.hospital.id
      }
      this._databaseResourcesService.saveTime(params).subscribe(data => {
        let response = data as ResponseDataBase;
        if (response.METADATA.STATUS == AppConstants.STATUS.OK) {
          this.getConsultant(this.consultant.id);
        } else {
          this._resourceService.alert = response.METADATA.ERROR_MESSAGE;
        }
        delete this.action;
        this._databaseResourcesService.loading = false;
      });
    }
  }

  removeException(hospitalSchedule, exception, period) {
    let modal = this.modalService.open(ConfirmationModalComponent, {
      windowClass: 'modal-fade',
      backdrop: 'static',
      keyboard: false,
      size: 'sm'
    });
    modal.componentInstance.header = 'REMOVE_EXCEPTION';
    modal.componentInstance.message = 'CONFIRM_REMOVE';
    modal.componentInstance.data = { action: "delete", hospitalSchedule: hospitalSchedule, exception: exception, period: period };
    modal.componentInstance.action.subscribe((response) => {
      response.exception.periods = response.exception.periods.filter(el => el.firstDay !== response.period.firstDay);
      this.saveException(response.hospitalSchedule, response.exception, period);
    });
  }

  areInArray(item, array) {
    if (array && item) {
      return array.some(arrayItem => arrayItem.id == item.id);
    }
  }

  areInArrayByMail(item, array) {
    if (array && item) {
      return array.some(arrayItem => arrayItem.email == item.email);
    }
  }

  areAllChoosed(arr, target) {
    let checker = arr.every(item => this.areInArray(item, target));
    return checker
  }

  ngAfterViewChecked() {
    if (this.selectedHospital) {
      $('.nav-tabs a[href="#' + this.selectedHospital.id + '"]').tab('show');
    }
  }

  ngAfterViewInit() {


  }

  ngOnInit() {


  }


}
